//Extracted out of FFMenu.js to be reused in other places.

export default function getStandaloneHost() {
    const scripts = Array.from(document.getElementsByTagName('script'));
    return (
        scripts
            .map(d => d.src)
            .filter(d => d) //remove undefined/nulls
            .find(d => d.includes('standalone-menu-entry'))
            //beta exists under plan static assets, so we specifically need to set the beta host
            ?.replace(
                'https://static.plan.foreflight.com/scripts/beta-standalone-menu-entry-v2.js',
                'https://beta.foreflight.com'
            )
            ?.replace('/scripts/standalone-menu-entry.js', '')
            ?.replace('/scripts/standalone-menu-entry-v2.js', '')
            //remove '/static.' (as in https://static.plan...) AND /static (as in plan.ff.com/static/)
            //   \b\/*\b removes the slash preceding 'static': plan.ff.com/static/
            //          (\b is boundary, grabs only the slash at beginning, \/ grabs the slash)
            //   \.* removes the period following static: 'static.plan.ff.com'
            // plan.ff.com/static is the old way, and once dispatch is moved over that could prob be removed.
            ?.replace(/\b\/*\bstatic\.*/g, '')
    );
}
